/**
 * Get API base URL dynamically based on environment
 * - Always use relative path /api to leverage Vite proxy in development
 * - In production: proxy or reverse proxy handles /api routing
 */
export const getApiBaseUrl = (): string => {
  // Always return empty string to use relative URLs with proxy
  return '';
};

/**
 * Convert relative URL to absolute URL using API base
 * @param url - Relative or absolute URL
 * @returns Absolute URL
 */
export const toAbsoluteUrl = (url: string): string => {
  if (!url) return '';

  // Already absolute
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Relative URL - prepend API base
  const baseUrl = getApiBaseUrl();
  // Ensure url starts with /
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${baseUrl}${path}`;
};
